/* eslint-disable object-property-newline */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import classes from '../classes.module.scss';
import {
  getTopSection, renderGeneralMessage
} from './processing_status_utils';
import { trackPageVisit } from '../../../actions/analytics';
import { setMessageToAppData } from '../../../actions/message_to_app';
import { messageToAppKeys } from '../../../../common/message_to_app_handler';
import { getPurchaseFailedPropsForMobileApp } from '../purchases_utils';

const trackPageVisitHandler = (okMessage, isAffiliatePromoPopup, errorType) => {
  if (okMessage && !isAffiliatePromoPopup) trackPageVisit('payment received popup');
  if (errorType === 'spending_limits') trackPageVisit('increase spending limit popup');
};

function MobileProcessingStatus({
  purchaseResponce,
  t, isCreditCard,
  isAffiliatePromoPopup, purchaseAmount, bonus, error, type, currentPaymentOption, purchaseFees, chatType
}) {
  const location = useLocation();
  const {
    okMessage, errorMessage, errorType
  } = purchaseResponce || {};
  useEffect(() => {
    trackPageVisitHandler(okMessage, isAffiliatePromoPopup, errorType);
  }, [errorType, okMessage]);

  useEffect(() => {
    if (errorMessage) {
      const purchaseFailedProps = getPurchaseFailedPropsForMobileApp({
        ...purchaseResponce, type, purchaseAmount, bonus, currentPaymentOption, purchaseFees, chatType, location
      });
      window.store.dispatch(setMessageToAppData({
        sentToAppMessage: {
          [messageToAppKeys.action]: messageToAppKeys.analytics,
          [messageToAppKeys.params]: {
            analytic_events: {
              'purchase failed': {
                ...purchaseFailedProps
              }
            }
          }
        }
      }));
    }
  }, [errorMessage]);

  const onErrorClick = () => {
    if (errorType === 'spending_limits') {
      window.store.dispatch(setMessageToAppData({
        sentToAppMessage: {
          [messageToAppKeys.action]: messageToAppKeys.navigationUpdate,
          [messageToAppKeys.params]: {
            [messageToAppKeys.route]: 'spending_limit'
          }
        }
      }));
    }
    window.store.dispatch(setMessageToAppData({
      sentToAppMessage: {
        [messageToAppKeys.action]: messageToAppKeys.dismiss
      }
    }));
  };

  const getErrorButtonTitle = () => {
    if (errorType === 'spending_limits') return t('paypal_purchase.increase_spending_limits');
    return t('general.ok');
  };

  const errorButton = () => {
    if (errorMessage || error) {
      return (
        <div className={ classes.botomContainer }>
          <div className={ classes.errorButtonContainer }>
            <button
              type="button"
              className={ classes.errorA }
              onClick={ onErrorClick }
            >
              <div className={ classes.confirmButtonA }>
                { getErrorButtonTitle() }
              </div>
            </button>
          </div>
        </div>
      );
    }
    return null;
  };

  const renderProcessingStatus = () => (
    <div className={ classes.dialogContainerMobile }>
      <div>
        { getTopSection({
          errorMessage, t, okMessage,  isAffiliatePromoPopup, purchaseAmount, bonus
        }) }
      </div>
      <br className={ classes.dialogContainerBr } />
      <div style={ { display: 'flex' } }>
        { renderGeneralMessage({
          isAffiliatePromoPopup, okMessage, bonus, errorMessage, error, isCreditCard, t
        }) }
      </div>
      <br className={ classes.dialogContainerBr } />
      <div className={ classes.bottomRowMobile }>
        { errorButton() }
      </div>
    </div>
  );

  return renderProcessingStatus();
}

MobileProcessingStatus.propTypes = {
  purchaseResponce: PropTypes.object,
  t: PropTypes.func.isRequired,
  isCreditCard: PropTypes.bool,
  purchaseURL: PropTypes.string,
  chatType: PropTypes.string,
  isSideMenu: PropTypes.bool,
  isAffiliatePromoPopup: PropTypes.bool.isRequired,
  purchaseAmount: PropTypes.number,
  bonus: PropTypes.number.isRequired,
  error: PropTypes.object,
  type: PropTypes.string,
  currentPaymentOption: PropTypes.object,
  purchaseFees: PropTypes.number
};

MobileProcessingStatus.defaultProps = {
  purchaseResponce: {},
  userLoading: false,
  isCreditCard: false,
  onFocusProcessingWindow: null,
  error: null,
  type: null,
  currentPaymentOption: null,
  purchaseFees: null,
  chatType: null
};

export default MobileProcessingStatus;
